"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormLabel = _interopRequireDefault(require("@mui/material/FormLabel"));
var _RadioGroup = _interopRequireDefault(require("@mui/material/RadioGroup"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RadioGroupHeading = _styledComponents["default"].div.withConfig({
  displayName: "radio_group__RadioGroupHeading"
})(["font-family:'Untitled Sans',sans-serif;", ";font-size:12px;color:", ";margin-bottom:2px;"], (0, _constants.fontWeight)('normal'), _constants.colors.darkGrey);
var RadioGroupContainer = _styledComponents["default"].div.withConfig({
  displayName: "radio_group__RadioGroupContainer"
})(["margin:14px 0;"]);
function RadioGroup(props) {
  return /*#__PURE__*/React.createElement(_FormControl["default"], {
    component: "fieldset"
  }, props.title && /*#__PURE__*/React.createElement(_FormLabel["default"], {
    component: "legend"
  }, /*#__PURE__*/React.createElement(RadioGroupHeading, null, props.title)), /*#__PURE__*/React.createElement(RadioGroupContainer, null, /*#__PURE__*/React.createElement(_RadioGroup["default"], {
    "aria-label": props.name,
    name: props.name,
    value: props.value,
    onChange: props.onChange
  }, props.children)));
}
var _default = exports["default"] = RadioGroup;